import TokenService from "@/services/token.service";
import AuthService from "@services/auth.service";
import { defaultApi } from '@/api/internalApis';
import WebStorage from "@/common/WebStorage";


// Instâncias já interceptadas, para que chamadas repetidas não empilhem interceptors
const tenantConfiguredApis = new WeakSet();
const authorizationConfiguredApis = new WeakSet();

const resolveTenantId = () => {
	const tokenData = WebStorage.getItem("tokenData");
	const accountInfo = JSON.parse(WebStorage.getItem("accountInfo") || 'null');

	return WebStorage.getItem("tenantId")
		|| tokenData?.Tenant
		|| accountInfo?.tenantId;
};

export const setupHeaderTenant = (apiList) => {
	apiList.forEach(commonApi => {
		if (tenantConfiguredApis.has(commonApi)) return;
		tenantConfiguredApis.add(commonApi);

		commonApi.interceptors.request.use(
			(config) => {
				const tenantId = resolveTenantId();

				if (!config.headers["X-Tenant"] && tenantId) {
					config.headers["X-Tenant"] = tenantId;
				}

				return config;
			},
			(error) => {
				return Promise.reject(error);
			},
		);
	});
};

// Mantida por compatibilidade: o header já é resolvido a cada requisição a partir
// do WebStorage, então basta garantir que o interceptor esteja registrado.
export const setupHeaderAliareTenant = () => {
	setupHeaderTenant([defaultApi]);
};

export const setupHeaderBearerAuthorization = (apiList, store) => {
	apiList.forEach(commonApi => {
		if (authorizationConfiguredApis.has(commonApi)) return;
		authorizationConfiguredApis.add(commonApi);

		commonApi.interceptors.request.use(
			(config) => {
				const token = TokenService.getTokens();

				if (token) {
					config.headers["Authorization"] = 'Bearer ' + token?.access_token;  // for Spring Boot back-end
				}

				return config;
			},
			(error) => {
				return Promise.reject(error);
			},
		);

		commonApi.interceptors.response.use(
			(response) => response,
			async (error) => {
				const originalConfig = error.config;

				if (originalConfig.url !== AuthService.getSignInUrl() && error.response) {
					// Access Token was expired

					if (error.response.status === 401 && !originalConfig._retry) {
						originalConfig._retry = true;

						try {
							const response = await AuthService.silentRefresh();
							const { status } = response;

							if (status == '204') {
								store.dispatch('auth/updateTokens', TokenService.getTokens());
							} 

							return commonApi(originalConfig);
						} catch (_error) {
							await AuthService.logout();
							return Promise.reject(_error);
						}
					}
				}

				return Promise.reject(error);
			},
		);
	});
};

export default setupHeaderBearerAuthorization;
